import styled from "@emotion/styled";
import { Box } from "@mui/system";
import { CSSObject } from "@emotion/react";
import { shouldForwardProp } from "./Common.style";

type LoaderProp = {
  showLoader: boolean;
  fullSizeLoader: boolean;
  isZoomed: boolean;
  enableZoom: boolean;
  containerStyle?: CSSObject;
};

export const DisplayImageContainer = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<LoaderProp>(
      [
        "fullSizeLoader",
        "containerStyle",
        "showLoader",
        "isZoomed",
        "enableZoom",
      ],
      prop,
    ),
})<LoaderProp>(
  ({ showLoader, fullSizeLoader, containerStyle, isZoomed, enableZoom }) => ({
    height: "100%",
    width: "100%",

    ...(showLoader && {
      backgroundImage: "url('/images/image_placeholder.gif')",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: fullSizeLoader ? "cover" : "auto",
    }),

    ...(enableZoom && {
      cursor: isZoomed ? "default" : "pointer",
      userSelect: "none",
    }),

    ...(containerStyle ?? {}),
  }),
);
